import React from 'react';

const Kpi = ({ label, value, hint, variant = 'default' }) => (
  <div className={`rhs-kpi-card rhs-kpi-card--${variant}`}>
    <div className="rhs-kpi-value">{value}</div>
    <div className="rhs-kpi-label">{label}</div>
    {hint && <div className="rhs-kpi-hint">{hint}</div>}
  </div>
);

/**
 * GOVOPS-1111 — executive KPI row for /admin operations dashboard.
 */
const OperationalKpiCards = ({ kpis = {} }) => (
  <div className="rhs-kpi-grid rhs-kpi-grid--admin">
    <Kpi label="Total permits" value={kpis.totalPermits ?? 0} variant="primary" />
    <Kpi
      label="Active / in progress"
      value={kpis.activePermits ?? 0}
      hint="Permits not yet closed"
      variant="active"
    />
    <Kpi
      label="Resolved / closed"
      value={kpis.resolvedClosedPermits ?? 0}
      hint="Permits completed"
      variant="done"
    />
    <Kpi
      label="Violations open"
      value={kpis.violationsOpen ?? 0}
      hint={`${kpis.totalViolations ?? 0} total violations`}
      variant="alert"
    />
    <Kpi
      label="Cases in review"
      value={kpis.casesInReview ?? 0}
      hint={`${kpis.totalCases ?? 0} total cases`}
      variant="review"
    />
    <Kpi label="Appeals" value={kpis.appeals ?? 0} variant="appeal" />
    <Kpi
      label="Unpaid permits"
      value={kpis.unpaidPermits ?? 0}
      hint="Balance due or unpaid status"
      variant="alert"
    />
    <Kpi
      label="Overdue payments"
      value={kpis.overduePayments ?? 0}
      variant="violation"
    />
    <Kpi
      label="Renewals due"
      value={kpis.renewalsDue ?? 0}
      hint="Within 30 days"
      variant="review"
    />
  </div>
);

export default OperationalKpiCards;
